/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Input, message, Row } from "antd";
import axios from "axios";

import { useEffect } from "react";
import TextArea from "antd/lib/input/TextArea";

import { ButtonCustom } from "../../../container/document/styled";
import { useTranslation } from "react-i18next";
import {
  DraggerFile,
  FormWrapper,
  Title,
  TitleUpdateDoc,
  UploadWrapper,
} from "../../../container/FormInputData/styled";
import { linkApi } from "../../../common/ngok";

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

const Createfrom = ({ selected, getDataDocument, setSelected }) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);
  const [docName, setDocName] = useState("");
  const [docNote, setDocNote] = useState("");

  useEffect(() => {
    setDocName("");
    setDocNote("");
    setFileList([]);
  }, []);

  const handleUpload = async () => {
    const token = localStorage.getItem("token")
      ? JSON.parse(localStorage.getItem("token"))
      : null;

    const formData = new FormData();
    formData.append("docfile", fileList[0]);
    formData.append("docname", docName);
    formData.append("docnote", docNote);
    formData.append("doctype", "general_doc");
    formData.append("is_public", "True");

    try {
      await axios.post(`${linkApi}/dm/data/docs`, formData, {
        headers: {
          Authorization: `Token ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      getDataDocument((res) => {
        if (res) {
          message.success(t("document.createSuccess"));
          setSelected(res);
        }
      });
    } catch (error) {
      message.error(t("document.createError"));
    }
  };

  const props = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isPdf = file.type === "application/pdf";
      if (!isPdf) {
        message.error(t("document.pdfOnly"));
        return false;
      }
      const isUnderLimit = file.size <= MAX_FILE_SIZE;
      if (!isUnderLimit) {
        message.error(t("document.fileTooLarge"));
        return false;
      }
      setFileList([file]);
      return false;
    },
    accept: ".pdf",
    fileList,
  };

  return (
    <FormWrapper>
      <>
        <TitleUpdateDoc>{t("document.createDocument")}</TitleUpdateDoc>
        <Title>{t("document.documentName")}</Title>
        <Input
          placeholder={t("document.documentName")}
          className="width-300"
          value={docName}
          onChange={(e) => setDocName(e?.target?.value)}
        />

        <Title>{t("document.documentNote")}</Title>
        <TextArea
          placeholder={t("document.documentNote")}
          className="width-300"
          value={docNote}
          onChange={(e) => setDocNote(e?.target?.value)}
        />
        {/* <RadioButtonCustom /> */}

        <Title>{t("document.uploadCertification")}</Title>
        <DraggerFile
          height={130}
          style={{ width: 300 }}
          maxCount={1}
          value={fileList}
          {...props}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">{t("document.clickDrag")}</p>
        </DraggerFile>
        <UploadWrapper>
          <Row>
            <ButtonCustom
              type="primary"
              onClick={handleUpload}
              disabled={fileList.length === 0 || !docName || !docNote}
            >
              {t("document.save")}
            </ButtonCustom>
          </Row>
        </UploadWrapper>
      </>
    </FormWrapper>
  );
};

export default Createfrom;
